import { _ as __decorate, a as __metadata, B as BaseComponent } from '../index-C155IGn1.js';
import { css, html } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import 'lit/directive.js';

var styles = css`.thumb-nav {
  --bsi-thumb-nav-gap: var(--bsi-spacing-xxs);
  --bsi-thumb-nav-auto-basis-offset: var(--bsi-spacing-s);
  --bsi-thumb-nav-overlay-offset: var(--bsi-spacing-s);
  --bsi-thumb-nav-item-width: 240px;
  --bsi-thumb-nav-item-width-small: 120px;
  --bsi-thumb-nav-item-height-small-vertical: 80px;
  --bsi-thumb-nav-overlay-bg-primary: var(--bsi-overlay-background-primary);
  --bsi-thumb-nav-overlay-bg-black: var(--bsi-overlay-background-light);
  --bsi-thumb-nav-hover-scale: 1.05;
  --bsi-thumb-nav-transition-duration: 0.4s;
  --bsi-thumb-nav-transition-duration-hover: 1s;
  --bsi-thumb-nav-transition-easing: cubic-bezier(0.15, 0.7, 0.36, 0.99);
  display: flex;
  justify-content: center;
  margin: 0 calc(var(--bsi-thumb-nav-gap) * -1);
  padding: 0;
}
.thumb-nav.thumb-nav-vertical {
  flex-direction: column;
  align-items: baseline;
}
.thumb-nav.thumb-nav-vertical .thumb-nav-resizer {
  width: auto;
  height: 100%;
}
.thumb-nav.thumb-nav-vertical.thumb-nav-small li {
  height: var(--bsi-thumb-nav-item-height-small-vertical);
}
.thumb-nav.thumb-nav-fixed {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.thumb-nav.thumb-nav-fixed li {
  flex-basis: var(--bsi-thumb-nav-item-width);
}
.thumb-nav.thumb-nav-fixed.thumb-nav-small li {
  flex-basis: var(--bsi-thumb-nav-item-width-small);
}
.thumb-nav.thumb-nav-auto {
  flex-wrap: wrap;
  justify-content: flex-start;
}
.thumb-nav.thumb-nav-auto li .thumb-nav-resizer {
  max-width: 100%;
  max-height: 100%;
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-2 li {
  flex-basis: calc(50% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-3 li {
  flex-basis: calc(33.3333% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-4 li {
  flex-basis: calc(25% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-auto.thumb-nav-auto-5 li {
  flex-basis: calc(20% - var(--bsi-thumb-nav-auto-basis-offset));
}
.thumb-nav.thumb-nav-nozoom a:hover img {
  transform: none;
}
.thumb-nav.thumb-nav-black a:hover:after, .thumb-nav.thumb-nav-primary a:hover:after {
  opacity: 1;
}
.thumb-nav.thumb-nav-black a:after {
  background: var(--bsi-thumb-nav-overlay-bg-black);
}
.thumb-nav.thumb-nav-primary a:after {
  background: var(--bsi-thumb-nav-overlay-bg-primary);
}
.thumb-nav.thumb-nav-bottom, .thumb-nav.thumb-nav-top {
  position: absolute;
  left: 50%;
  width: 90%;
  transform: translateX(-50%);
}
.thumb-nav.thumb-nav-bottom {
  bottom: 0;
  margin-bottom: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-top {
  top: 0;
  margin-top: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-left, .thumb-nav.thumb-nav-right {
  position: absolute;
  top: 50%;
  height: 90%;
  transform: translateY(-50%);
}
.thumb-nav.thumb-nav-left {
  left: 0;
  margin-left: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav.thumb-nav-right {
  right: 0;
  margin-right: var(--bsi-thumb-nav-overlay-offset);
}
.thumb-nav li {
  position: relative;
  flex: 0 1 auto;
  width: var(--bsi-thumb-nav-item-width);
  margin: var(--bsi-thumb-nav-gap);
  list-style-type: none;
}
.thumb-nav .thumb-nav-resizer {
  visibility: hidden;
  width: 100%;
  height: auto;
}
.thumb-nav.thumb-nav-small li {
  width: var(--bsi-thumb-nav-item-width-small);
}
.thumb-nav a {
  position: relative;
  display: block;
  overflow: hidden;
}
.thumb-nav a:after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  content: "";
  opacity: 0;
  transition: opacity var(--bsi-thumb-nav-transition-duration) var(--bsi-thumb-nav-transition-easing);
}
.thumb-nav a.active {
  pointer-events: none;
}
.thumb-nav a.active:after {
  opacity: 1;
  background: var(--bsi-thumb-nav-overlay-bg);
}
.thumb-nav a:hover img {
  transform: scale(var(--bsi-thumb-nav-hover-scale));
  transition-duration: var(--bsi-thumb-nav-transition-duration-hover);
}
.thumb-nav a:hover:after {
  transition-duration: var(--bsi-thumb-nav-transition-duration-hover);
}
.thumb-nav a img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: transform var(--bsi-thumb-nav-transition-duration) var(--bsi-thumb-nav-transition-easing);
  object-fit: cover;
}

:host {
  display: block;
}

ul {
  list-style: none;
}
@supports (font: -apple-system-body) and (-webkit-appearance: none) {
  ul {
    list-style: disc;
  }
}

.thumb-nav ::slotted(it-thumbnav-item) {
  position: relative;
  width: 240px;
  flex: 0 1 auto;
  margin: 8px;
}

.thumb-nav.thumb-nav-small ::slotted(it-thumbnav-item) {
  width: 120px;
}

.thumb-nav.thumb-nav-vertical.thumb-nav-small ::slotted(it-thumbnav-item) {
  height: 80px;
}

.thumb-nav.thumb-nav-fixed ::slotted(it-thumbnav-item) {
  width: auto;
  flex-basis: 240px;
}

.thumb-nav.thumb-nav-fixed.thumb-nav-small ::slotted(it-thumbnav-item) {
  flex-basis: 120px;
}

.thumb-nav.thumb-nav-auto ::slotted(it-thumbnav-item) {
  width: auto;
}

.thumb-nav.thumb-nav-auto.thumb-nav-auto-2 ::slotted(it-thumbnav-item) {
  flex-basis: calc(50% - 16px);
}

.thumb-nav.thumb-nav-auto.thumb-nav-auto-3 ::slotted(it-thumbnav-item) {
  flex-basis: calc(33.3333% - 16px);
}

.thumb-nav.thumb-nav-auto.thumb-nav-auto-4 ::slotted(it-thumbnav-item) {
  flex-basis: calc(25% - 16px);
}

.thumb-nav.thumb-nav-auto.thumb-nav-auto-5 ::slotted(it-thumbnav-item) {
  flex-basis: calc(20% - 16px);
}

:host([hover=black]) {
  --it-thumbnav-overlay-bg: rgb(0, 0, 0);
  --it-thumbnav-overlay-hover-opacity: 0.8;
}

:host([hover=primary]) {
  --it-thumbnav-overlay-bg: var(--bsi-color-background-primary);
  --it-thumbnav-overlay-hover-opacity: 0.8;
}`;

/**
 * Contenitore Thumbnav: lista di link con immagini thumbnail.
 * I singoli elementi vanno inseriti tramite `it-thumbnav-item`.
 *
 * ```html
 * <it-thumbnav>
 *   <it-thumbnav-item>
 *     <a href="#" class="ratio ratio-3x2"><img src="…" alt="…"></a>
 *   </it-thumbnav-item>
 * </it-thumbnav>
 * ```
 */
let ItThumbnav = class ItThumbnav extends BaseComponent {
    constructor() {
        super(...arguments);
        /** Usa thumbnail di dimensione ridotta (120px invece di 240px). */
        this.small = false;
        /**
         * Dispone le thumbnail in colonna verticale.
         * Viene applicato automaticamente quando `position` è `left` o `right`.
         */
        this.vertical = false;
        /** Larghezza fissa per ogni thumbnail (240px o 120px se `small`). */
        this.fixed = false;
        this._setChildrenProperties = () => {
            for (const item of this._items) {
                item.role = 'listitem';
            }
        };
    }
    get _items() {
        if (!this._slotEl)
            return [];
        return this._slotEl
            .assignedElements({ flatten: true })
            .filter((el) => el.tagName === 'IT-THUMBNAV-ITEM');
    }
    updated() {
        this._setChildrenProperties();
    }
    render() {
        const effectiveVertical = this.vertical || this.position === 'left' || this.position === 'right';
        const classes = classMap({
            'thumb-nav': true,
            'thumb-nav-small': this.small,
            'thumb-nav-vertical': effectiveVertical,
            'thumb-nav-fixed': this.fixed,
            'thumb-nav-nozoom': this.hover === 'nozoom',
            'thumb-nav-black': this.hover === 'black',
            'thumb-nav-primary': this.hover === 'primary',
            'thumb-nav-auto': this.auto != null,
            [`thumb-nav-auto-${this.auto}`]: this.auto != null,
            'thumb-nav-bottom': this.position === 'bottom',
            'thumb-nav-top': this.position === 'top',
            'thumb-nav-left': this.position === 'left',
            'thumb-nav-right': this.position === 'right',
        });
        return html `<ul class="${classes}" part="thumbnav" role="list">
      <slot @slotchange=${this._setChildrenProperties}></slot>
    </ul>`;
    }
};
ItThumbnav.styles = styles;
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItThumbnav.prototype, "small", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItThumbnav.prototype, "vertical", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItThumbnav.prototype, "fixed", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItThumbnav.prototype, "hover", void 0);
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Number)
], ItThumbnav.prototype, "auto", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItThumbnav.prototype, "position", void 0);
__decorate([
    query('slot'),
    __metadata("design:type", HTMLSlotElement)
], ItThumbnav.prototype, "_slotEl", void 0);
ItThumbnav = __decorate([
    customElement('it-thumbnav')
], ItThumbnav);

export { ItThumbnav };
//# sourceMappingURL=it-thumbnav.js.map
